import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';

injectGlobal(`
  @media (min-width: 1400px) {
    .container {
      max-width: 1300px;
    }
  }
  @media (min-width: 1700px) {
    .container {
      max-width: 1600px;
    }
  }
  .container-fluid {
    max-width: 1600px;
  }
  .btn {
    background-color: ${colors.color2};
    transition: all .3s ease;
    color: #000000;
    border-radius: 5px;
    padding: 10px 15px;
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 2px;
    border-radius: 0;
    &:hover {
      background-color: ${colors.color2Light};
      color: #000000;
    }
  }
  #LoAvailableBtn {
    bottom: 70px !important;
    @media(min-width: 400px) {
      bottom: 67px !important;
    }
    @media(min-width: 992px) {
      bottom: 0 !important;
    }
  }
  .react-player__preview {
    &:hover {
      .react-player__shadow {
        background: ${colors.color2} !important;
      }
    }

  }
  .react-player__shadow {
    background: ${colors.color1} !important;
    border-radius: 50% / 10% !important;
    color: #FFFFFF;
    font-size: 2em;
    height: 75px !important;
    width: 100px !important;
    margin: 20px auto;
    padding: 0;
    position: relative;
    text-align: center;
    text-indent: 0.1em;
    transition: all 150ms ease-out;
    width: 4em;
    display: block !important;
    @media(min-width: 992px) {
      height: 95px !important;
      width: 140px !important;
    }
    &:hover {
    }
    &::before {
      background: inherit;
      border-radius: 5% / 50%;
      bottom: 9%;
      content: "";
      left: -5%;
      position: absolute;
      right: -5%;
      top: 9%;
    }
    &::after {
      border-style: solid;
      border-width: 1em 0 1em 1.732em;
      border-color: transparent transparent transparent rgba(255, 255, 255, 1);
      content: ' ';
      font-size: 0.45em;
      height: 0;
      margin: -1em 0 0 -0.75em;
      top: 50%;
      position: absolute;
      width: 0;
      @media(min-width: 992px) {
        font-size: 0.65em;
      }
    }
  }
  .react-player__play-icon {
    display: none !important;
  }
  .Btn_default {
    height: 45px;
    font-weight: 700;
    font-size: 15px;
    color: #FFFFFF;
    letter-spacing: 0.12px;
    background-color: ${colors.color1};
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    @media(min-width: 992px) {
      height: 53px;
      font-size: 17px;
      letter-spacing: 0;
    }
  }
  a {
    font-weight: 700;
  }
`);



// WEBPACK FOOTER //
// ./src/styles/reset.js